// extracted by mini-css-extract-plugin
module.exports = {"remark-div":"remark-div-bb8961cbefa3e937ebc17fb7f96e06c4","award-audit-table-button":"award-audit-table-button-1b27c9af50bdd0296398c31b2bd6577b"};